export const DOCUMENT_DELETE_PERMISSIONS = Object.freeze([
  'RECEIVESLIP_DEL',
  'SL_PAYMENTSLIP_DEL',
  'SL_RECEIVE_PAYMENT_CASH_DEL',
  'SL_RECEIVE_PAYMENT_CREDIT_DEL',
  'SL_INVOICE_CANCEL',
  'SL_ORDER_INVOICE_CANCEL',
  'SL_SALES_INVOICE_CANCEL',
  'SL_ORDER_CANCEL_REPLACE_INVOICE',
]);

export const requiresDocumentDeletePermission = (permissions = []) =>
  (Array.isArray(permissions) ? permissions : [permissions]).some(
    (permission) => DOCUMENT_DELETE_PERMISSIONS.includes(`${permission || ''}`.replace(/\s+/g, '').toUpperCase()),
  );
